import React, { Fragment, useState } from "react";
import { Grid, Button, Typography, Avatar, useTheme, useMediaQuery, Box, makeStyles, } from "@material-ui/core";
import { complaintTypesService, usersCachingService, stagesService } from "../../services";
import { useFieldLookup } from "../../hooks/useFieldLookup";
import { CaseLeadDialog } from "./activities/dialogs/CaseLeadDialog";
import { CaseAssignDialog } from "./activities/dialogs/CaseAssignDialog";
import { useAuthorizationForCase } from "../../hooks/useAuthorization";
import { CaseRoles } from "../../auth/CaseRoles";
import { utcToLocalDate, utcToLocalDateTime } from "../../utils/dateUtils";
import { Warning } from "@material-ui/icons";
const useStyles = makeStyles(theme => ({
    iconSection: {
        padding: 10,
    },
    icon: {
        fontSize: "3rem",
    },
    messageSection: {},
}));
export const Header = ({ item }) => {
    const [openDialog, setOpenDialog] = useState(false);
    const lookup = useFieldLookup(complaintTypesService, item.caseType);
    const caseLeadName = useFieldLookup(usersCachingService, item.caseLead);
    const assignedToName = useFieldLookup(usersCachingService, item.assignedTo);
    const stage = useFieldLookup(stagesService, item.stage);
    const isAuthedForActivityEdit = useAuthorizationForCase(item === null || item === void 0 ? void 0 : item.id, CaseRoles.admin);
    const classes = useStyles();
    const calculateInitials = (name) => {
        const splitName = name.split(" ");
        let initials = "";
        splitName.forEach((section) => (initials = initials.concat(section[0])));
        return initials;
    };
    const theme = useTheme();
    const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));
    return (React.createElement(Fragment, null,
        React.createElement(Grid, { container: true, className: "RecordHeaderBar" },
            React.createElement("div", { className: "section" },
                React.createElement("div", null,
                    React.createElement("label", null, "Case ID:"),
                    " ",
                    React.createElement("span", { "data-test": "header-ofqual-id" }, item.ofqualId)),
                React.createElement("div", null,
                    React.createElement("label", null, "Type:"),
                    " ",
                    React.createElement("span", { "data-test": "header-case-type" }, lookup)),
                React.createElement("div", null,
                    React.createElement("label", null, "Status:"),
                    "  ",
                    React.createElement("span", { "data-test": "header-status" }, item.status))),
            React.createElement("div", { className: "section" },
                React.createElement("div", null,
                    React.createElement("label", null, "Created:"),
                    " ",
                    React.createElement("span", { "data-test": "header-created-date" }, utcToLocalDateTime(item.createdDate))),
                React.createElement("div", null,
                    React.createElement("label", null, "Received:"),
                    " ",
                    React.createElement("span", { "data-test": "header-recieved-date" }, utcToLocalDate(item.receiptDate))),
                React.createElement("div", null,
                    React.createElement("label", null, "Stage:"),
                    " ",
                    React.createElement("span", { "data-test": "header-stage" }, stage))),
            isLgUp && (React.createElement("div", { className: "section" },
                React.createElement(Button, { onClick: () => setOpenDialog("CaseLead"), 
                    // startIcon={<AccountCircleIcon fontSize="large" />}
                    disabled: !isAuthedForActivityEdit, "data-test": "case-lead" },
                    React.createElement("div", { className: "LeftAlign", style: { margin: "auto", marginLeft: 0 } },
                        React.createElement(Grid, { container: true },
                            React.createElement(Grid, { item: true, xs: 4 }, caseLeadName ? (React.createElement("div", null,
                                React.createElement(Avatar, { style: { backgroundColor: "#293445" } }, calculateInitials(caseLeadName)))) : (React.createElement(Avatar, { style: { backgroundColor: "#293445" } }))),
                            React.createElement(Grid, { item: true, xs: 8, className: "CaseLeadLabel" },
                                React.createElement(Grid, { container: true, direction: "column", alignItems: "stretch" },
                                    React.createElement(Grid, { item: true },
                                        React.createElement(Typography, null,
                                            React.createElement("label", { style: { textTransform: "none" } }, "Case Lead"))),
                                    React.createElement(Grid, { item: true },
                                        React.createElement(Typography, { style: { textTransform: "none" } }, caseLeadName ? caseLeadName : "Not Set"))))))))),
            isLgUp && (React.createElement("div", { className: "section" },
                React.createElement(Button, { onClick: () => setOpenDialog("CaseAssign"), 
                    // startIcon={<AccountCircleIcon fontSize="large" />}
                    disabled: !isAuthedForActivityEdit, "data-test": "case-assign" },
                    React.createElement("div", { className: "LeftAlign", style: { margin: "auto", marginLeft: 0 } },
                        React.createElement(Grid, { container: true },
                            React.createElement(Grid, { item: true, xs: 4 }, item.assignedTo ? (React.createElement("div", null,
                                React.createElement(Avatar, { style: { backgroundColor: "#293445" } }, calculateInitials(assignedToName)))) : (React.createElement(Avatar, { style: { backgroundColor: "#293445" } }))),
                            React.createElement(Grid, { item: true, xs: 8, className: "CaseLeadLabel" },
                                React.createElement(Grid, { container: true, direction: "column", alignItems: "stretch" },
                                    React.createElement(Grid, { item: true },
                                        React.createElement(Typography, null,
                                            React.createElement("label", { "data-test": "assigned-to-button", style: { textTransform: "none" } }, "Assigned To"))),
                                    React.createElement(Grid, { item: true },
                                        React.createElement(Typography, { style: { textTransform: "none" } }, assignedToName ? assignedToName : "Not Set"))))))))),
            item.slaPaused ? (React.createElement("div", { className: "section" },
                React.createElement(Grid, { item: true },
                    React.createElement(Box, { display: "flex", alignItems: "center" },
                        React.createElement("div", { className: classes.iconSection },
                            React.createElement(Warning, { className: classes.icon })),
                        React.createElement(Typography, { className: classes.messageSection, "data-test": "validation-text" },
                            React.createElement("b", null, "SLA paused")))))) : null,
            !isLgUp && (React.createElement("div", { className: "section" },
                React.createElement("div", null,
                    React.createElement(Button, { onClick: () => setOpenDialog("CaseLead"), 
                        // startIcon={<AccountCircleIcon fontSize="large" />}
                        disabled: !isAuthedForActivityEdit, "data-test": "case-lead" },
                        React.createElement("div", null,
                            React.createElement("label", { style: { textTransform: "none" } }, "Case Lead:"),
                            " ",
                            React.createElement("span", { "data-test": "header-ofqual-id", style: { textTransform: "none" } }, caseLeadName ? caseLeadName : "Not Set")))),
                React.createElement("div", null,
                    React.createElement(Button, { onClick: () => setOpenDialog("CaseAssign"), 
                        // startIcon={<AccountCircleIcon fontSize="large" />}
                        disabled: !isAuthedForActivityEdit, "data-test": "case-assign" },
                        React.createElement("div", null,
                            React.createElement("label", { style: { textTransform: "none" } }, "Assigned To:"),
                            " ",
                            React.createElement("span", { "data-test": "header-ofqual-id", style: { textTransform: "none" } }, assignedToName ? assignedToName : "Not Set"))))))),
        openDialog === "CaseLead" && (React.createElement(CaseLeadDialog, { caseId: item.id, isDialogOpen: openDialog === "CaseLead", onDialogClose: () => setOpenDialog(false) })),
        openDialog === "CaseAssign" && (React.createElement(CaseAssignDialog, { caseId: item.id, isDialogOpen: openDialog === "CaseAssign", onDialogClose: () => setOpenDialog(false) }))));
};
